import { combineReducers } from 'redux';

import { lottery, lotteryApplication } from './lotteryApplication';
import { lotteries } from './lotteries';
import { inventoryContent } from './inventoryContent';

const reducers = combineReducers({
    lottery,
    lotteryApplication,
    inventoryContent,
    lotteries,
});

export default reducers;
